
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/vehicles",
      function () {
        return require("private-next-pages/user/vehicles.js");
      }
    ]);
  